import React, { Component } from 'react';
import './Subcategories.css';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  FormGroup,
  Label,
  Input,
  FormText
} from 'reactstrap';
import classnames from 'classnames';
import { IconPlus, IconMinus, IconRemove } from '../../Icons/Icons';
import update from 'react-addons-update';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  removeSubcategory,
  updateSubcategories
} from '../../../store/editStoreActions';
import lodashDebounce from 'lodash.debounce';

import SubCategory from './SubCategory';
import SubCategoryViewAll from './SubCategoryViewAll';

class Subcategories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openSubcategories: [],
      subcategories: this.props.subcategories,
      modified: this.props.modified
    };

    this.updateSubcategoriesRedux = lodashDebounce(() => {
      this.props.updateSubcategories(
        this.props.categoryIndex,
        this.state.subcategories
      );
    }, 100);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.modified && !nextProps.modified) {
      return {
        subcategories: nextProps.subcategories,
        modified: nextProps.modified
      };
    }
    if (prevState.subcategories && nextProps.subcategories) {
      if (prevState.subcategories.length !== nextProps.subcategories.length) {
        return {
          subcategories: nextProps.subcategories,
          modified: nextProps.modified
        };
      }
    }
    if (nextProps.modified) {
      return {
        modified: nextProps.modified
      };
    }
    return null;
  }

  updateSubcategories(e, index) {
    let { value } = e.target;
    let inputId = e.target.id;
    let nameToId = this.props.subcategories[index].id;
    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    }

    if (inputId === 'name') {
      nameToId = value.replace(/\s+/g, '-').toLowerCase();
    }

    const subcategories = this.state.subcategories;
    const newSubcategories = update(subcategories, {
      [index]: { [inputId]: { $set: value }, id: { $set: nameToId } }
    });

    this.setState({ subcategories: newSubcategories });
    this.updateSubcategoriesRedux();
  }

  rearrangeSubcategories(moveFromIndex, moveToIndex) {
    const subcategories = this.state.subcategories;
    const currentSubcategory = subcategories[moveFromIndex];
    let newSubcategories = update(subcategories, {
      $splice: [[moveFromIndex, 1]]
    });

    newSubcategories = update(newSubcategories, {
      $splice: [[parseInt(moveToIndex, 10), 0, currentSubcategory]]
    });

    this.setState({ subcategories: newSubcategories });
    this.updateSubcategoriesRedux();
  }

  toggleSubcategory(index) {
    const openSubcategories = this.state.openSubcategories;
    const indexIsOpen = openSubcategories.indexOf(index) > -1;
    let newOpenSubcategoriesArray = openSubcategories;

    if (!indexIsOpen) {
      newOpenSubcategoriesArray[newOpenSubcategoriesArray.length] = index;
      this.setState({ openSubcategories: newOpenSubcategoriesArray });
    } else {
      newOpenSubcategoriesArray.splice(openSubcategories.indexOf(index), 1);
      this.setState({
        openSubcategories: newOpenSubcategoriesArray
      });
    }
  }

  render() {
    const { removeSubcategory, categoryIndex } = this.props;
    const { openSubcategories, subcategories } = this.state;
    if (!subcategories || !subcategories.length > 0) {
      return null;
    }
    return (
      <div className="sections subcategories">
        {subcategories.map((subcategory, subcategoryIndex) => {
          const isOpen = openSubcategories.indexOf(subcategoryIndex) > -1;
          return (
            <Card key={subcategoryIndex}>
              <CardHeader
                className={classnames({
                  open: openSubcategories.indexOf(subcategoryIndex) > -1
                })}
              >
                {isOpen ? (
                  <React.Fragment>
                    <h5 className="toggle">
                      <span
                        onClick={() => this.toggleSubcategory(subcategoryIndex)}
                      >
                        <IconMinus />
                      </span>

                      <Input
                        id="name"
                        onChange={e =>
                          this.updateSubcategories(e, subcategoryIndex)
                        }
                        value={subcategory.name || ''}
                      />
                      <small
                        onClick={() => this.toggleSubcategory(subcategoryIndex)}
                      >
                        ({subcategory.id})
                      </small>
                    </h5>
                  </React.Fragment>
                ) : (
                  <h5
                    className="toggle"
                    onClick={() => this.toggleSubcategory(subcategoryIndex)}
                  >
                    <IconPlus />
                    <span>
                      {subcategory.name} <small>({subcategory.id})</small>
                    </span>
                  </h5>
                )}
                <div>
                  <FormGroup inline>
                    <Input
                      title="Change subcategory order"
                      type="select"
                      id="order"
                      bsSize="sm"
                      onChange={e =>
                        this.rearrangeSubcategories(
                          subcategoryIndex,
                          e.target.value
                        )
                      }
                      value={subcategoryIndex || ''}
                    >
                      {subcategories.map((subcategory, index) => (
                        <option key={index} value={index}>
                          {index + 1}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  <Button
                    color="primary"
                    onClick={() =>
                      removeSubcategory(categoryIndex, subcategoryIndex)
                    }
                    size="sm"
                    outline
                    title="Remove subcategory"
                  >
                    <IconRemove />
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                <Collapse
                  isOpen={openSubcategories.indexOf(subcategoryIndex) > -1}
                >
                  <div className="flex-form">
                    <FormGroup className="flex-100">
                      <Label
                        check
                        title="Show as view all sub category"
                        className={'switch-toggle'}
                      >
                        <Input
                          title="Show as view all sub category"
                          onChange={e =>
                            this.updateSubcategories(e, subcategoryIndex)
                          }
                          id="viewAll"
                          type="checkbox"
                          checked={subcategory.viewAll === true}
                        />
                        <div className="slider" />
                        <span>View all</span>
                      </Label>
                      <FormText color="muted">
                        Products from all subcategories will displayed within
                        this category tile.
                      </FormText>
                    </FormGroup>

                    {subcategory.viewAll !== true ? (
                      <SubCategory
                        subcategory={subcategory}
                        subcategoryIndex={subcategoryIndex}
                        imageBasePath={this.props.imageBasePath}
                        updateSubcategories={this.updateSubcategories.bind(
                          this
                        )}
                      />
                    ) : (
                      <SubCategoryViewAll
                        subcategory={subcategory}
                        subcategoryIndex={subcategoryIndex}
                        imageBasePath={this.props.imageBasePath}
                        updateSubcategories={this.updateSubcategories.bind(
                          this
                        )}
                      />
                    )}
                  </div>
                </Collapse>
              </CardBody>
            </Card>
          );
        })}
      </div>
    );
  }
}
const mapStateToProps = ({ activeStore }, ownProps) => ({
  subcategories:
    activeStore.activeStore &&
    activeStore[activeStore.activeStore] &&
    activeStore[activeStore.activeStore].categories &&
    activeStore[activeStore.activeStore].categories[ownProps.categoryIndex]
      ? activeStore[activeStore.activeStore].categories[ownProps.categoryIndex]
          .subcategories
      : null,
  imageBasePath:
    activeStore.activeStore && activeStore[activeStore.activeStore]
      ? activeStore[activeStore.activeStore].imageBasePath
      : null,
  modified: activeStore.modified
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      removeSubcategory,
      updateSubcategories
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Subcategories);



// WEBPACK FOOTER //
// ./src/components/categories/Subcategories/Subcategories.js